import React from "react";
import { SectionHeader } from "@/sections/Services";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-6">
            <SectionHeader
              eyebrow="About"
              title="A UK technology studio with practical, commercial roots."
            />
          </div>
          <div className="lg:col-span-6 space-y-6 text-[16px] md:text-[17px] text-slate-300 leading-relaxed">
            <p className="mk-reveal">
              Mackbe Tech Ltd has been trading since October 2019, working alongside
              UK SMEs, startups and professional services firms to bring digital ideas
              to life. We design and build websites, mobile apps, web platforms, internal
              systems and AI-powered digital products.
            </p>
            <p className="mk-reveal" style={{ transitionDelay: "120ms" }}>
              Our work spans practical, service-led industries — from gyms and cafés to
              accountants, law firms and hospitality operators — giving us a clear
              understanding of how real businesses actually run.
            </p>
            <p className="mk-reveal" style={{ transitionDelay: "240ms" }}>
              Today, we are evolving from a development company into a product-focused
              technology studio: alongside client work, we are building our own portfolio
              of digital products, apps and ventures.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
